import React from 'react'
import '../css/global.css'
import ComingSoon from './ComingSoon'

const App = () => <ComingSoon />

export default App
